import { render, staticRenderFns } from "./LeftBarDistribution.vue?vue&type=template&id=5c3c7222&"
import script from "./LeftBarDistribution.vue?vue&type=script&lang=js&"
export * from "./LeftBarDistribution.vue?vue&type=script&lang=js&"
import style0 from "./LeftBarDistribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports